export class TransactionLogs{
    date: string;
    ekpay_id: string;
    mobile: string;
    pg_txns_id: string;
    receipt_no: string;
}

export class ViewTransactionLogs{
    response: string;
    reason: string;
    txns_logs: TxnsLog[];
}

export class TxnsLog {
    bank_charges: number;
    biller_name: string;
    bill_accno: string;
    bill_amount: number;
    bill_due_date: string;
    bill_from_date: string;
    bill_gen_date: string;
    bill_last_paid_date: string;
    bill_late_fee: number;
    bill_meter_no: string;
    bill_mobile_no: string;
    bill_no: string;
    bill_rev_stamp: number;
    bill_total_amount: number;
    bill_to_date: string;
    bill_type: string;
    bill_vat: string;
    bill_xchange_code: string;
    cust_email: string;
    cust_mobile: string;
    cust_name: string;
    discount_amount: number;
    discount_promo_amount: number;
    ekpay_fee: number;
    ekpay_id: string;
    gateway: string;
    isntrument_name: string;
    merchant_name: string;
    method_name: string;
    payee_mode: string;
    payment_time: Date;
    pi_card_no: string;
    pi_pay_amount: number;
    pi_status_msg: string;
    pi_total_paid_amount: number;
    receipt_no: string;
    reg_email: string;
    reg_mobile: string;
    selected_pi_name: string;
    service_name: string;
    service_provider: string;
    service_type: string;
    txns_id: string;
    txns_journey_state: string;
    txns_time: Date;
    txns_type: string;
    cust_address: string;
}




// WEBPACK FOOTER //
// ./src/app/logs/transaction-logs/view-transaction-logs.ts